import type { IGetMultiLabels } from './interfaces/IGetMultiLabels';

function getMultiLabels({ values }: IGetMultiLabels) {
  return values.join(', ');
}

export default getMultiLabels;
